import { LIGHT_LOGO_TILE } from '~/utils/get-filler-image';

type Props = {
  name: string;
  brand: string;
  category: string;
  image: string;
  lightLogo: boolean;
  price: number;
  originalPrice: number;
  discounted: boolean;
  quantity: number;
  onIncrease: () => void;
  onDecrease: () => void;
  onRemove: () => void;
};

export default function CartItemRow({
  name,
  brand,
  category,
  image,
  lightLogo,
  price,
  originalPrice,
  discounted,
  quantity,
  onIncrease,
  onDecrease,
  onRemove,
}: Props) {
  const controlClass =
    'flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-lg font-bold text-[#264B9A] hover:bg-[#264B9A] hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#264B9A]';
  return (
    <article className="rounded-lg border border-gray-200 bg-white p-2.5">
      <div className="flex items-start gap-2">
        <figure
          className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md ${lightLogo ? LIGHT_LOGO_TILE : ''}`}
        >
          <img src={image} alt="" className="h-12 w-12 object-contain" loading="lazy" />
        </figure>
        <div className="min-w-0 flex-1 pt-0.5">
          <h3
            title={name}
            className="font-poppins line-clamp-2 text-xs leading-4 font-bold text-[#14294F]"
          >
            {name}
          </h3>
          <p
            title={`${brand} · ${category}`}
            className="mt-1 truncate text-[10px] leading-3 text-gray-600"
          >
            {brand}
            {brand && category ? ' · ' : ''}
            {category}
          </p>
        </div>
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remove ${name} from cart`}
          className="-mt-1 -mr-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-gray-500 hover:bg-red-50 hover:text-red-700 focus-visible:outline-2 focus-visible:outline-[#264B9A]"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            aria-hidden="true"
          >
            <path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7" />
          </svg>
        </button>
      </div>
      <div className="mt-1 flex items-center justify-between gap-2">
        <div className="flex flex-wrap items-baseline gap-x-1.5">
          <span className="text-sm font-bold text-[#264B9A]">
            ${(discounted ? price : originalPrice).toFixed(2)}
          </span>
          {discounted && (
            <del className="text-[11px] text-gray-500">${originalPrice.toFixed(2)}</del>
          )}
        </div>
        <div className="flex shrink-0 items-center rounded-lg bg-gray-100">
          <button
            type="button"
            onClick={onDecrease}
            aria-label={`Decrease quantity of ${name}`}
            className={controlClass}
          >
            −
          </button>
          <span
            aria-label={`Quantity: ${quantity}`}
            className="min-w-6 text-center text-xs font-semibold text-[#14294F]"
          >
            {quantity}
          </span>
          <button
            type="button"
            onClick={onIncrease}
            aria-label={`Increase quantity of ${name}`}
            className={controlClass}
          >
            +
          </button>
        </div>
      </div>
    </article>
  );
}
